import { render, staticRenderFns } from "./StoragesManagerForm.vue?vue&type=template&id=09df5fb2&"
import script from "./StoragesManagerForm.vue?vue&type=script&lang=ts&"
export * from "./StoragesManagerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports